import React from "react";
import { styled } from "@mui/system";
import PropTypes from "prop-types";
import Box from "../Box";
import Typography from "../Typography";
import Divider from "../Divider";

const Item = (props: any) => {
  const { sx, ...children } = props;

  return (
    <Box
      sx={{
        px: 0.5,
        ...sx,
      }}
      {...children}
    />
  );
};

type Props = {
  size?: String;
  title?: String;
  description?: String;
  reduced?: Boolean;
  divider?: Boolean;
  leftItems?: React.ReactNode[];
  rightItems?: React.ReactNode[];
};

export const HeaderBar = styled(
  (props: Props) => (
    <Box
      sx={{
        width: "100%",
        height: props.size === "small" ? "48px" : "80px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          py: props.size === "small" ? "4px" : "18px",
          px: props.size === "small" ? "4px" : "9px",
          alignItems: "center",
          bgcolor: "transparent",
        }}
      >
        {props.leftItems
          ? props.leftItems.map((item, index) => {
              return <Item key={index}>{item}</Item>;
            })
          : null}

        <Box
          sx={{
            flexGrow: 1,
            textAlign: props.reduced ? "left" : "center",
            pl: props.size === "small" ? "8px" : "15px",
            direction: "column",
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              padding: 0,
              lineHeight: 1.5,
              fontSize:
                props.size === "small" ? 16 : props.description ? 20 : 24,
            }}
            variant="titleSmall"
          >
            {props.title}
          </Typography>
          {props.description ? (
            <Typography
              sx={{ padding: 0, lineHeight: 1 }}
              variant="pageDescription"
            >
              {props.description}
            </Typography>
          ) : null}
        </Box>
        {props.rightItems
          ? props.rightItems.map((item, index) => {
              return <Item key={index}>{item}</Item>;
            })
          : null}
      </Box>
      {props.divider ? (
        <Divider
          sx={{ height: 1.5, backgroundColor: "primary.interactiveDefault" }}
          variant="fullWidth"
        />
      ) : null}
    </Box>
  ),
  {
    name: "HeaderBar",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({}));
